// @flow
import { type State, type ProcessadorPeriodo } from "../../../../../state";
import {
  type Id,
  type MedidaSelecionada,
  ID_PERIODO_DATAS_INDICADORES_MERCADO,
  MAP_ID_TIPO_QUANTIDADE_DIAS_REFERENCIA_POR_PERIODO,
} from "../../../../../model";

export const processarPeriodoDatasIndicadoresMercado: ProcessadorPeriodo = (
  periodo: Id,
  state: State,
  medidasSelecionadas: Array<MedidaSelecionada>
) => {
  const _medidasSelecionadas: Array<MedidaSelecionada> = [];

  medidasSelecionadas.forEach(medidaSelecionada => {
    _medidasSelecionadas.push({
      ...medidaSelecionada,
      periodo: ID_PERIODO_DATAS_INDICADORES_MERCADO,
      tipoQuantidadeDiasReferencia:
        MAP_ID_TIPO_QUANTIDADE_DIAS_REFERENCIA_POR_PERIODO[periodo],
    });
  });

  return _medidasSelecionadas;
};
